import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/dashboard/_trucks/caminhoes/modelos/editar/")({
  beforeLoad: () => {
    throw redirect({ to: ".." });
  }
});
